// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "AccountBadge__textCenter__aztqI";
export const accountBadge = "AccountBadge__accountBadge__kBRQT";
export const details = "AccountBadge__details__t+97b";
export const cardDetails = "AccountBadge__cardDetails__fEi0Y";
export const baseAccountName = "AccountBadge__baseAccountName__pa+5-";
export const accountName = "AccountBadge__accountName__iYmC8";
export const accountNameInner = "AccountBadge__accountNameInner__9Y6V4";
export const tooltipIconWrapper = "AccountBadge__tooltipIconWrapper__Iag2e";